<template>
  <div class="organ_device_tabs-bd ubv">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="icon icon-guanlian" v-if="permission.add" :disabled="!(organ.bizId || user.bizId)" @click="onBindEvent">
            {{ $t('Common.com_added') }}
          </el-button>
          <el-button type="primary" icon="icon icon-quxiaoguanlian" v-if="permission.del" :disabled="!tableSelect.length" @click="onUnbindEvent">
            {{ $t('Common.com_remove') }}
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_organ_device_bind.jshModemSNjqmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_organ_device_bind.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.shou_hou_gong_si')">
          <el-input v-model="formSearch.scOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.dai_li_gong_si')">
          <el-input v-model="formSearch.jvOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.zu_lin_fang')">
          <el-input v-model="formSearch.csOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.ji_tuan_ke_hu')">
          <el-input v-model="formSearch.bigCsOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_bind.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="organ_device" v-model="tableSelect" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 手工分配弹窗 -->
    <bind-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess()"></bind-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import bindDeviceDialog from '@/pages/base/components/bindDeviceDialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [resetFormSearchMixins],
  components: { bindDeviceDialog },
  props: {
    permission: {
      type: Object,
      default() {
        return {};
      },
    },
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        bizId: '',
        bizType: '',
        isAss: 1, // 已关联
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        productCode: '',
        scOrgName: '',
        jvOrgName: '',
        csOrgName: '',
        bigCsOrgName: '',
        locationName: '',
        contractNo: '',
      },
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {
        data: {},
      },
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getDeviceList();
    },
    user: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getDeviceList();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDeviceList();
  },
  methods: {
    // 获取关联设备
    getDeviceList: function () {
      this.formSearch.bizId = this.user && this.user.bizId ? this.user.bizId : this.organ.bizId;
      this.formSearch.bizType = this.user && this.user.bizId ? this.user.bizType : this.organ.bizType;
      this.$getJSON(apis.DeviceBindAutoDevicePage, this.formSearch).then((res) => {
        const list = res.data.list;
        list.forEach((item) => {
          item.isExists = !!item.isAuto;
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 取消关联设备
    onUnbindEvent: function () {
      // 您确定要取消分配选中的设备吗？
      this.$showConfirm(this.user && this.user.bizId ? this.$t('base_organ_device_bind.nqdyjxzdjqcxzdygzyc') : this.$t('base_organ_device_bind.nqdyjxzdjqcxzdbmzyc'))
        .then(() => {
          this.cancelDevice();
        })
        .catch(() => {});
    },
    cancelDevice: function () {
      const deviceIds = this.tableSelect.map((t) => t.deviceId);
      this.$postJSON(apis.BizDeviceUnbind, {
        bizId: this.user && this.user.bizId ? this.user.bizId : this.organ.bizId,
        deviceIds,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.getDeviceList();
      });
    },
    // 关联设备
    onBindEvent: function () {
      this.dialogModel.title = this.$t('base_organ_device_bind.jjqtjgyh');
      this.dialogModel.data.user = this.user;
      this.dialogModel.data.organ = this.organ;
      this.dialogModel.data.tableCode = 'organ_device';
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 分配成功
    onSuccess() {
      this.$emit('success');
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.organ_device_tabs-bd {
  height: 100%;
}
</style>
